module.exports = __webpack_public_path__ + "img/延时视频.d2d45de2.jpg";